import { useEffect } from 'react';
import { useSocket } from '@/providers/socket-provider';
import { useQueryClient } from '@tanstack/react-query';

export function useAuthenticatedMatches() {
  const { subscribe, connected } = useSocket();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!connected) {
      console.log('Not subscribing to AuthenticatedMatchesChannel - WebSocket not connected');
      return;
    }

    console.log('Attempting to subscribe to AuthenticatedMatchesChannel');

    // Subscribe to the authenticated matches channel
    const unsubscribe = subscribe(
      'AuthenticatedMatchesChannel',
      {},
      {
        connected: () => {
          console.log('Successfully connected to AuthenticatedMatchesChannel');
        },
        disconnected: () => {
          console.log('Disconnected from AuthenticatedMatchesChannel');
        },
        received: (data) => {
          console.log('Received message from AuthenticatedMatchesChannel:', data);
        }
      }
    );

    return () => {
      console.log('Unsubscribing from AuthenticatedMatchesChannel');
      unsubscribe();
    };
  }, [connected, subscribe, queryClient]);
}
